<template>
  <v-dialog v-model="dialog" width="600">
    <v-card>
      <v-card-title>
        <v-layout align-center>
          <v-flex> Image Gallery </v-flex>
          <v-flex text-right>
            <v-btn icon @click="cancel">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <div class="mx-4">
        <v-layout class="mt-3">
          <v-flex xs6>
            <div class="subtitle-2 mb-1">Select Entity</div>
            <v-autocomplete
              :loading="loading"
              v-model="entity"
              :items="reviewedEntities"
              cache-items
              :search-input.sync="searchTerm"
              return-object
              item-text="title"
              item-value="title"
              placeholder="Select Entity"
              persistent-hint
              hint="Select an entity to show images for the entity"
              no-data-text="Type a name of an entity to search"
              outlined
              chips
              dense
              @change="getAssetsByEntity"
            ></v-autocomplete>
          </v-flex>
          <v-flex text-right>
            <v-btn
              color="primary"
              class="text-none subtitle-2 my-4"
              @click="openImageUploadDialog"
            >
              <v-icon small class="mr-2"> mdi-image-multiple </v-icon>
              <div>Upload Images</div>
            </v-btn>
          </v-flex>
        </v-layout>

        <v-layout class="mt-3" align-end>
          <v-flex>
            <div class="subtitle-2">Select images to attach</div>
          </v-flex>
          <v-flex text-right>
            <!-- <v-layout> -->
            <v-btn-toggle v-model="toggle_exclusive" mandatory>
              <v-btn icon>
                <v-icon> mdi-dots-grid </v-icon>
              </v-btn>
              <v-btn icon>
                <v-icon> mdi-format-list-text </v-icon>
              </v-btn>
            </v-btn-toggle>
            <!-- </v-layout> -->
          </v-flex>
        </v-layout>

        <!-- <v-card outlined class="mt-3"> -->
      </div>

      <v-container v-if="toggle_exclusive === 0" class="mt-3" grid-list>
        <v-row>
          <v-col
            cols="3"
            class="d-flex child-flex"
            v-for="(item, i) in assets"
            :key="i"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-hover v-slot="{ hover }">
                  <v-card
                    @click="selectImage(item, i)"
                    :elevation="hover ? 12 : 2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-img
                      aspect-ratio="1"
                      :lazy-src="item.image.url"
                      :src="item.image.url"
                    >
                      <v-btn
                        :key="componentKey"
                        :color="item.selected ? 'primary' : ''"
                        fab
                        @click="selectImage(item, i)"
                        x-small
                        class="ma-1"
                      >
                        <v-icon> mdi-check </v-icon>
                      </v-btn>
                    </v-img>
                  </v-card>
                </v-hover>
              </template>
              <span>{{ item.entity.title }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-container>
      <v-simple-table v-else>
        <template v-slot:default>
          <thead>
            <tr>
              <th>Select</th>
              <th>Image</th>

              <th class="text-left">Entity Name</th>
              <th class="text-left">Created At</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, i) in assets"
              :key="`list-${i}`"
              @click="selectImage(item, i)"
              style="cursor: pointer"
            >
              <td>
                <v-btn
                  :key="componentKey"
                  :color="item.selected ? 'primary' : 'grey'"
                  fab
                  :outlined="item.selected ? false : true"
                  @click="selectImage(item, i)"
                  x-small
                  class="ma-1"
                >
                  <v-icon> mdi-check </v-icon>
                </v-btn>
              </td>
              <td class="py-4">
                <v-card width="50">
                  <v-img aspect-ratio="1" :src="item.image.url" />
                </v-card>
              </td>

              <td>
                {{ item.entity.title }}
              </td>
              <td>{{ iMoment(item.createdAt) }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-layout class="py-10" v-if="assets.length === 0">
        <v-flex text-center class="mx-10 grey--text text--darken-2 body-2">
          Looks like there are no Images for that Entity. Try another entity or
          upload images from the gallery.
        </v-flex>
      </v-layout>
      <v-layout justify-center v-if="assets.length > 0">
        <v-btn
          v-if="entity"
          color="primary"
          class="text-none subtitle-2 my-4"
          @click="getMoreAssetsByEntityId(entity.id)"
        >
          Load more
        </v-btn>
        <v-btn
          v-else
          color="primary"
          class="text-none subtitle-2 my-4"
          @click="getMoreAssets()"
        >
          Load more
        </v-btn>
      </v-layout>
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="cancel"
          color="error"
          class="text-none subtitle-2"
          outlined
        >
          Cancel
        </v-btn>
        <v-btn color="primary" class="text-none subtitle-2" @click="save">
          <span> Save </span>
        </v-btn>
      </v-card-actions>

      <!-- </v-card> -->
    </v-card>
    <upload-image-dialog ref="uploadImageDialogRef" />
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import moment from "moment";
import UploadImageDialog from "./UploadImageDialog.vue";
export default {
  components: {
    UploadImageDialog,
  },
  data() {
    return {
      dialog: false,
      searchTerm: "",
      entity: "",
      loading: false,
      toggle_exclusive: 0,
      selectedImages: [],
      componentKey: 0,
    };
  },
  computed: {
    ...mapState("$_assets", ["assets"]),
    ...mapState("$_entity", ["reviewedEntities"]),
  },
  created() {
    this.getAssets();
  },
  watch: {
    searchTerm: _.debounce(function (e) {
      e && this.searchEntities(e);
    }, 300),
  },
  methods: {
    ...mapActions({
      getAssets: "$_assets/getAssets",
      getMoreAssets: "$_assets/getMoreAssets",
      searchEntitiesAction: "$_entity/searchContent",
      getAssetsByEntityId: "$_assets/getAssetsByEntityId",
      getMoreAssetsByEntityId: "$_assets/getMoreAssetsByEntityId",
    }),
    forceRerender() {
      this.componentKey += 1;
    },

    iMoment(timestamp) {
      if (timestamp) {
        let temp = timestamp.seconds * 1000;
        return moment(temp).format("lll");
      } else {
        return 0;
      }
    },
    searchEntities(searchTerm) {
      this.loading = true;
      console.log("searching Tags: ", searchTerm);

      this.searchEntitiesAction({
        collection: "entities",
        mutation: "updateReviewedEntities",
        searchTerm: searchTerm,
      }).then(() => {
        this.loading = false;
      });
    },
    getAssetsByEntity(entity) {
      console.log("EntityL ", entity);
      if (entity) {
        this.getAssetsByEntityId(entity.id);
      }
    },
    selectImage(item, index) {
      if (this.assets[index].selected) {
        this.assets[index].selected = false;
        this.selectedImages.splice(index, 1);
        this.forceRerender();
      } else {
        this.assets[index].selected = true;
        this.selectedImages.push(item);
        this.forceRerender();
      }
    },
    save() {
      console.log("selectImages", this.selectedImages);
      this.$emit("save", this.selectedImages);
      this.cancel();
    },
    toggleDialog() {
      this.dialog = !this.dialog;
    },
    cancel() {
      this.searchTerm = "";
      this.entity = "";
      this.assets.forEach((asset) => {
        asset.selected = false;
      });

      this.selectedImages = [];
      this.forceRerender();
      this.dialog = false;
    },
    openImageUploadDialog() {
      this.$refs.uploadImageDialogRef.toggleDialog();
    },
  },
};
</script>

<style>
</style>